<template>
  <v-container fluid>
    <v-row justify="center">
      <h2>{{ $t('title_HallOfFameForex') }}</h2>
    </v-row>
    <v-row align="center" justify="center">
      <LeaderboardList :ranked-accounts="rankedAccounts" :my-invests="myInvests"/>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/leaderboard';
import LeaderboardList from "@/views/Leaderboard/components/LeaderboardList";

export default {
  name: "HallOfFameForex",
  components: {LeaderboardList},
  data() {
    return {
      rankedAccounts: [],
      myInvests: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.getInvestmentVotesByUser().then((response) => {
        if(response.status < 400)
          this.myInvests = response.data;
      });

      Repository.getLastLeaderboardByMarket('Forex').then((response) => {
        if(response.status < 400) {
          let leaderboard = response.data;
          Repository.getRankedAccountsByLeaderboard(leaderboard.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.rankedAccounts = secondResponse.data;
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>


